import React, { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Menu, X, Phone } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white/95 backdrop-blur-md shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div
            className="flex items-center space-x-2 cursor-pointer"
            onClick={() => scrollToSection("hero")}
          >
            <img
              src="https://ranselpro.com/tim/logo-ranselpro.png"
              alt="RanselPro Logo"
              className="w-10 h-10 rounded-md object-contain"
            />
            <span className="text-xl font-bold text-gray-800"></span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {[
              { label: "Beranda", id: "hero" },
              { label: "Tentang", id: "about" },
              { label: "Layanan", id: "services" },
              { label: "Portfolio", id: "portfolio" },
              { label: "Tim", id: "team" },
              { label: "Kontak", id: "contact" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-gray-700 hover:text-blue-600 transition-colors duration-200 font-medium"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="https://wa.me/6285133079588?text=Halo%20RanselPro!%20Saya%20ingin%20konsultasi%20tentang%20layanan%20multimedia."
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 transition-all duration-200 flex items-center">
                <Phone className="w-4 h-4 mr-2" />
                Hubungi Kami
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-800" />
            ) : (
              <Menu className="w-6 h-6 text-gray-800" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-lg shadow-lg border animate-fade-in">
            <nav className="flex flex-col space-y-2 px-4">
              {[
                { label: "Beranda", id: "hero" },
                { label: "Tentang", id: "about" },
                { label: "Layanan", id: "services" },
                { label: "Portfolio", id: "portfolio" },
                { label: "Tim", id: "team" },
                { label: "Kontak", id: "contact" },
              ].map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left text-gray-700 hover:text-blue-600 hover:bg-blue-50 transition-all duration-200 font-medium py-3 px-3 rounded-lg"
                >
                  {item.label}
                </button>
              ))}
              <a
                href="https://wa.me/6285133079588?text=Halo%20RanselPro!%20Saya%20ingin%20konsultasi%20tentang%20layanan%20multimedia."
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  onClick={() => scrollToSection("contact")}
                  className="bg-blue-600 hover:bg-blue-700 text-white mt-4 w-full py-3 min-h-[48px] flex items-center justify-center"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Hubungi Kami
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
